import EmptyStarredImg from '@static/images/empty-state/empty-starred.svg';
import { useTranslation } from 'react-i18next';

import styles from './EmptyStarred.module.scss';

export const EmptyStarred = () => {
  const { t } = useTranslation(['chat']);

  return (
    <div className={styles.emptyStarredWrapper}>
      <EmptyStarredImg />
      <h4 className={styles.title}>
        {t('chat:starredConversation.noStarredTitle')}
      </h4>
      <p className={styles.description}>
        {t('chat:starredConversation.noStarredDescription')}
      </p>
    </div>
  );
};
